import { render, staticRenderFns } from "./delivery-lead-single-debug.vue?vue&type=template&id=c48c7f08"
import script from "./delivery-lead-single-debug.vue?vue&type=script&lang=js"
export * from "./delivery-lead-single-debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports